module.exports = __webpack_public_path__ + "static/media/circular.ecb52126.gif";